<section id="kl-reccomendations-common">
  <p class="text-danger mb-0">Recommendations</p>
  <div *ngFor="let recommendation of recommendationsList" fxLayout>
    <div class="text-danger hiphen-style">- </div>
    <div class="ml-2">{{recommendation}}</div>
  </div>
</section>
